import { appFormUtil } from 'modules/common';
import React from 'react';

type IFormState = {
  withFiles: boolean;
  notSubmitted: boolean;
  withAccidents: boolean;
  withDeliveries: boolean;
  withInspections: boolean;
};

const initialState: IFormState = {
  withFiles: false,
  notSubmitted: false,
  withAccidents: false,
  withDeliveries: false,
  withInspections: false
};

export function useFormState() {
  const {
    formState,
    dispatch,
    genFieldProps
  } = appFormUtil.useFormState({
    initialState,
    key2FieldConfig: {
      withFiles: {
        label: 'With Files',
        type: 'checkbox'
      },
      notSubmitted: {
        label: 'Not Submitted',
        type: 'checkbox'
      },
      withAccidents: {
        label: 'With Incidents',
        type: 'checkbox'
      },
      withDeliveries: {
        label: 'With Deliveries',
        type: 'checkbox'
      },
      withInspections: {
        label: 'With Inspections',
        type: 'checkbox'
      }
    }
  });

  return React.useMemo(
    () => {


      return {
        formState,
        dispatch,
        genFieldProps
      };
    },
    [
      dispatch,
      formState,
      genFieldProps
    ]
  );
}
